import { businessWhatsAppHref } from './business';
import { pickTeEn } from '../utils/localizedContent.js';

export const WA_SUGGESTION_IDS = [
  'language',
  'guide',
  'subscribe',
  'payment',
  'login',
  'paper',
  'refund',
  'other',
];

export function getWhatsAppSuggestions(t, waTemplatesFromApi = null, lang = 'te') {
  if (Array.isArray(waTemplatesFromApi) && waTemplatesFromApi.length) {
    return waTemplatesFromApi
      .map((item) => ({
        id: item.id,
        label: pickTeEn(lang, item.labelTe, item.labelEn || item.labelTe),
        message: pickTeEn(lang, item.messageTe, item.messageEn || item.messageTe),
      }))
      .filter((item) => item.id && item.label && item.message);
  }
  return WA_SUGGESTION_IDS.map((id) => ({
    id,
    label: t[`waSuggest_${id}`],
    message: t[`waSuggest_${id}_msg`],
  })).filter((item) => item.label && item.message);
}

export function openBusinessWhatsApp(message) {
  const url = businessWhatsAppHref(message);
  const isMobile = typeof navigator !== 'undefined' && /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (isMobile) {
    window.location.assign(url);
    return;
  }
  window.open(url, '_blank', 'noopener');
}
